<ng-container  *ngIf="applicationStateService.state$ | async as appState">
    <router-outlet></router-outlet>

</ng-container>
